import { NavigationReason, isNavigationByInteraction, isNavigationByReason, } from './ubiTypes';
import { PageIdentifier } from './pageIdentifiers';
export { NavigationReason, PageIdentifier, isNavigationByInteraction, isNavigationByReason, };
//# sourceMappingURL=index.js.map